import {
  IModeleFormulaireWebServiceClient, ModeleFormulaireDto, CategorieFormulaireDto,
  ICategorieFormulaireWebServiceClient, ICorrespondantWebServiceClient
} from "@resources/resources";
import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve} from "@angular/router";

@Injectable()
export class EnregistrementModeleFormulaireResolver implements Resolve<ModeleFormulaireDto> {

  constructor(private modeleFormulaireWebService: IModeleFormulaireWebServiceClient) {
  }

  resolve(route: ActivatedRouteSnapshot) {
    let id = route.params['id'];
    return this.modeleFormulaireWebService.getModeleFormulaire(id);
  }
}

@Injectable()
export class TagsModeleFormulaireResolver implements Resolve<String[]> {

  constructor(private correspondantWebServiceClient: ICorrespondantWebServiceClient) {
  }

  resolve() {
    return this.correspondantWebServiceClient.getTags();
  }
}

@Injectable()
export class CategorieModeleFormulaireResolver implements Resolve<CategorieFormulaireDto[]> {

  constructor(private categorieFormulaireWebService: ICategorieFormulaireWebServiceClient) {
  }

  resolve() {
    return this.categorieFormulaireWebService.getCategorieFormulaireAll();
  }
}





// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-formulaire-demat/digicerba-formulaire-demat-web/src/angular/cerba/src/app/pages/cerba/pages/admin/gestion-modele/gestion-modele.resolver.ts